import { useMutation } from '@tanstack/react-query';
import axiosInstanceChat from '@/axios/axiosInstanceChat';
import { PrescreenMutationVariables } from '@/types';

export const useMutatePreescreenProcess = (
  chatId: string | undefined,
  language: string | null,
  otherParams: string | null,
  basePath: string | null,
) => {
  return useMutation({
    mutationFn: async ({ question, answers, conversation_id }: PrescreenMutationVariables) => {
      const queryParams = new URLSearchParams();

      if (conversation_id) queryParams.append('conversation_id', conversation_id);
      if (language) queryParams.append('language', language);

      const paramString = queryParams.toString();
      const fullUrl = `/chat/${basePath}/prescreen/${chatId}?${paramString}${
        otherParams ? `&${otherParams}` : ''
      }`;

      const response = await axiosInstanceChat.post(fullUrl, {
        question,
        answers,
      });

      return response.data;
    },
  });
};
